import { OrdersScreen } from "./orders.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { OrderEditRoutes } from "../order-edit";

export const OrdersRoutes: RouteDefinition[] = [
	{
		path: Paths.orders.path,
		element: <OrdersScreen />,
		requiredPermissions: ["UserInAccountPermission_OrderAdmin_Read"],
	},
	...OrderEditRoutes,
];
